import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { CreateClientSecret, DeleteClientSecret, useClient } from "./ClientStore";
import * as IdentityPermissionStore from "../identityPermissions/IdentityPermissionStore";

import { useParams } from "react-router-dom";
import { FormGroup, Input, Label } from "reactstrap";

const ClientPermissions = ({ user, policies }) => {
    const params = useParams();

    const [permissions, setPermissions] = React.useState([]);

    React.useEffect(() => {
        startManageClientPermissions();
    }, []);

    const startManageClientPermissions = () => {
        IdentityPermissionStore.ListPolicies().then((response) => {
            let policies = response.data;
            IdentityPermissionStore.GetClientPermissions(params.id).then((response) => {
                setPermissions(
                    policies.map((policy) => ({
                        policy,
                        userHasPolicy: response.data.filter((u) => u.permission == policy).length > 0,
                    }))
                );
            });
        });
    };

    let hasPermission = (permission) => {
        if (user && policies) {
            if (user.claims.filter((c) => c.type == "http://schemas.microsoft.com/ws/2008/06/identity/claims/role" && c.value == "Admin").length > 0) {
                return true;
            } else {
                return policies.filter((policy) => policy.permission == permission).length > 0;
            }
        }
        return false;
    };

    const handlePermissionChange = (permission) => (e) => {
        let value = e.target.checked;

        let promise = null;
        if (value) {
            promise = IdentityPermissionStore.GiveClientPermission(params.id, permission);
        } else {
            promise = IdentityPermissionStore.RevokeClientPermission(params.id, permission);
        }

        promise.then((response) => {
            startManageClientPermissions();
        });
    };

    return (
        <>
            {hasPermission("manageClientPermissions") && params.id && (
                <>
                    Manage permissions for client
                    <table className="table">
                        <thead>
                            <tr>
                                <th style={{ width: "70%" }}>Permission</th>
                            </tr>
                        </thead>
                        <tbody>
                            {permissions.map((permission) => (
                                <tr key={permission.policy}>
                                    <td>
                                        <FormGroup check>
                                            <Input
                                                type="switch"
                                                id={permission.policy}
                                                checked={permission.userHasPolicy}
                                                onChange={handlePermissionChange(permission.policy)}
                                                disabled={!hasPermission("manageClientPermissions")}
                                            />
                                            <Label for={permission.policy} check>
                                                {permission.policy}
                                            </Label>
                                        </FormGroup>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>
            )}
        </>
    );
};

export default ClientPermissions;
